import React, {Component} from "react";
import {connect} from "react-redux";
import {Link, Redirect} from "react-router-dom";
import {auth} from "../../actions/index";
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import {RadioButton} from "primereact/radiobutton";
import {Calendar} from "primereact/calendar";
import {Dropdown} from 'primereact/dropdown';

import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import default_profil from "../../resources/images/logo/user2.png";


class Register extends Component {

    constructor(props) {
        super(props);
        this.state = {
            image_file_max_size: 200,
            user_username: "",
            user_password: "",
            pers_tcid: "",
            pers_name: "",
            user_email: "",
            pers_surname: "",
            pers_birthday: null,
            pers_title: "",
            confirm_password: "",
            contact_content: "",
            genders: [],
            institutions: [],
            contact_types: [],
            departments: [],
            contacts: [],
            pers_photo: default_profil,
            contact_popup: false,
            institution: null,
            department: 1,
            contact_type: null,
            btn_add_visible: false,
            btn_update_visible: false,
            registration_dialog_visibility: false,
            registration_message: "",
            dialog_header_message: "",
            edit_row_index: null,

        };
        this.institutionInitalize = this.institutionInitalize.bind(this);
        this.getGenders = this.getGenders.bind(this);
        this.getDepartments = this.getDepartments.bind(this);
        this.getAllInstitutions = this.getAllInstitutions.bind(this);
        this.getAllContactTypes = this.getAllContactTypes.bind(this);
        this.addContact = this.addContact.bind(this);
        this.deleteContact = this.deleteContact.bind(this);
        this.createContactObject = this.createContactObject.bind(this);
        this.updateContact = this.updateContact.bind(this);
        this.logChange = this.logChange.bind(this);
    }

    componentDidMount() {
        this.getAllInstitutions();
        this.getAllContactTypes();
        this.getGenders();
    }

    onSubmit = e => {
        e.preventDefault();
        let person_data = {
            pers_tcid: parseInt(this.state.pers_tcid),
            pers_name: this.state.pers_name,
            pers_surname: this.state.pers_surname,
            pers_birthday: this.state.pers_birthday,
            pers_photo: this.state.pers_photo,
            dept_id: parseInt(this.state.department),
            gend_id: parseInt(this.state.gend_id),
            pers_title: this.state.pers_title,
            user_username: this.state.user_username,
            user_password: this.state.user_password,
            user_email: this.state.user_email,
            contacts: this.state.contacts,
        };

        this.props.register(person_data);
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            let nexPropsManagement = nextProps.management;
            if (nexPropsManagement.type === "REGISTRATION_SUCCESSFUL"
                && this.props.management !== nexPropsManagement) {
                if (nexPropsManagement.data.result === 1) {
                    this.setState({dialog_header_message: "Kayıt Başarılı!"});
                } else {
                    this.setState({dialog_header_message: "Kayıt Başarısız!"});
                }
                this.setState({
                    registration_dialog_visibility: true,
                    registration_message: nexPropsManagement.data.message
                })
            }

        }
    }

    institutionInitalize(inst_id) {
        this.setState({
            institution: inst_id,
            inst_id: inst_id,
            dept_id: null
        });
        this.getDepartments(inst_id)
    }

    getDepartments(inst_id) {
        if (inst_id != "" && Number.isInteger(parseInt(inst_id))) {
            let headers = {"Content-Type": "application/json"};
            fetch(`/api/user_departments/${inst_id}/`, {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                        if (res.status === 200) {
                            this.setState({departments: res.data});
                        } else if (res.status === 401) {
                            this.props.loadUser();
                            throw res.data;

                        } else if (res.status === 403) {
                            throw res.data;

                        }
                    }
                )
        }
    }

    getAllInstitutions() {
        let headers = {"Content-Type": "application/json"};

        fetch("/api/user_institutions/", {headers,})
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 200) {
                    this.setState({institutions: res.data});

                } else if (res.status === 401) {
                    this.props.loadUser();
                    throw res.data;

                } else if (res.status === 403) {
                    throw res.data;

                }
            })
    }

    getGenders() {
        let headers = {"Content-Type": "application/json"};
        fetch("/api/gender/", {headers,})
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 200) {
                    this.setState({genders: res.data});
                } else if (res.status === 401 || res.status === 403) {
                    //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                    throw res.data;
                }
            })
    }

    logChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChange(e) {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            let file_size = Math.round(file.size / 1000);
            reader.onload = () => {
                let fileInfo = {
                    name: file.name,
                    type: file.type,
                    size: file_size + ' kB',
                    base64: reader.result,
                    file: file,
                };
                if (file_size < this.state.image_file_max_size) {
                    this.setState({pers_photo: reader.result})
                } else {
                    alert("Resim Boyutu Çok Büyük Lütfen " + this.state.image_file_max_size + " KB'den Küçük Boyutlu Resim Seçiniz")
                }
            }
        }
    }

    getAllContactTypes() {
        let headers = {"Content-Type": "application/json"};
        fetch("/api/contact_types/", {headers,})
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};
                    })
                } else {
                    //console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 200) {
                    this.setState({contact_types: res.data});
                } else if (res.status === 401) {
                    this.props.loadUser();
                    throw res.data;
                    //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                } else if (res.status === 403) {
                    throw res.data;

                }
            })
    }

    addContact() {
        let contact_content = this.state.contact_content;
        let contact_arr = this.state.contact_type.split("--");
        let new_pers_contact_id = contact_arr[0];
        let new_pers_contact_name = contact_arr[1];
        let contacts_list = [];
        if (contact_content !== "") {
            contacts_list.push(this.createContactObject(new_pers_contact_id, new_pers_contact_name, contact_content));
        }
        if (contacts_list.length > 0) {
            this.setState({contacts: this.state.contacts.concat(contacts_list)});
            this.setState({
                contact_popup: false,
                btn_add_visible: false,
                btn_update_visible: false,
                contact_content: "",
                contact_type: "",
            });
        }
    }

    updateContact() {
        let contact_arr = this.state.contact_type.split("--");
        let ctyp_id = contact_arr[0];
        let contact_name = contact_arr[1];
        let temp = this.state.contacts;
        let row_index = this.state.edit_row_index;
        temp[row_index].ctyp_id = ctyp_id;
        temp[row_index].ctyp_name = contact_name;
        temp[row_index].pcon_content = this.state.contact_content;
        this.setState({
            contacts: temp,
            contact_popup: false,
            btn_add_visible: false,
            btn_update_visible: false,
            contact_content: "",
            contact_type: "",
        });

    }

    createContactObject(ctyp_id, ctyp_name, pcon_content) {
        return (
            {
                ctyp_id: ctyp_id,
                ctyp_name: ctyp_name,
                pcon_content: pcon_content,
            }
        )
    }

    deleteContact(rowIndex) {
        let temp = this.state.contacts;
        temp.splice(rowIndex, 1);
        this.setState({contacts: temp});
    }

    contacttypeButtons(rowData, column) {
        return (
            <div>
                <Button
                    type="button"
                    onClick={() => this.deleteContact(column.rowIndex)}
                    title="Sil"
                    icon="pi pi-trash"
                    className="p-button-success">
                </Button>
                <Button
                    type="button"
                    title="Düzenle"
                    icon="pi pi-pencil"
                    className="p-button-warning"
                    onClick={() => this.editContactInitalize(column.rowIndex)}>
                </Button>
            </div>
        );
    }

    editContactInitalize(row_index) {
        let contact = this.state.contacts[row_index];
        this.setState({
            contact_popup: true,
            contact_content: contact.pcon_content,
            contact_type: contact.ctyp_id + '--' + contact.ctyp_name,
            btn_add_visible: false,
            btn_update_visible: true,
            edit_row_index: row_index
        });
    }

    render() {

        let instOptionItems = [];
        let deptOptionItems = [];
        let genderOptionItems = [];
        let contactTypesItems = [];

        if (this.props.isAuthenticated) {
            return <Redirect to="/"/>
        }

        const registration_dialog_footer = (
            <div>
                <Link icon="pi pi-check" to="/login">
                    <Button label="Tamam" icon="pi pi-check" className="p-button-success"/>
                </Link>

            </div>
        );

        if (this.state.genders != null) {
            let gend = this.state.genders;
            genderOptionItems = gend.map((gender) =>

                <div className="p-col-12" key={gender.gend_name}>
                    <RadioButton
                        value={gender.gend_id}
                        inputId={gender.gend_name}
                        onChange={event => this.setState({gend_id: gender.gend_id})}
                        checked={this.state.gend_id == gender.gend_id}/>
                    <label
                        htmlFor={gender.gend_name}
                        className="p-radiobutton-label">
                        {gender.gend_name}
                    </label>
                </div>
            );
        }

        const institutions = this.state.institutions;
        instOptionItems = institutions.map((inst) => (
                {"label": inst.inst_name, "value": inst.inst_id}
            )
        );

        const departments = this.state.departments;
        deptOptionItems = departments.map((dept) => (
                {"label": dept.dept_name, "value": dept.dept_id}
            )
        );
        const contact_types = this.state.contact_types;
        contactTypesItems = contact_types.map((contact) => (
                {"label": contact.ctyp_name, "value": contact.ctyp_id + '--' + contact.ctyp_name}
            )
        );

        const tr = {
            firstDayOfWeek: 0,
            dayNames: ["pazartesi", "salı", "çarşamba", "perşembe", "cuma", "cumartesi", "pazar"],
            dayNamesShort: ["pzt", "sal", "çar", "per", "cum", "cmt", "pzr"],
            dayNamesMin: ["PT", "SA", "ÇA", "PE", "CU", "CT", "PA"],
            monthNames: ["ocak", "şubat", "mart", "nisan", "mayıs", "haziran", "temmuz", "ağustos", "eylül", "ekim", "kasım", "aralık"],
            monthNamesShort: ["ocak", "şub", "mart", "nisan", "mayis", "haziran", "temmuz", "ağus", "eyl", "ekm", "kas", "aralik"]
        };


        return (
            <div className="p-fluid">
                <form onSubmit={this.onSubmit.bind(this)}>
                    <div className="p-col-8 p-lg-offset-2  p-lg-8 p-justify-center">

                        <div className="card card-w-title " style={{marginTop: "5%"}}>
                            <center>
                                <h1>Kayıt Formu</h1>
                                <div className="profile">
                                    <div>
                                        <img src={this.state.pers_photo} alt=""
                                             style={{maxWidth: 130, maxHeight: 130}}/>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <input type="file"
                                           onChange={this.handleChange.bind(this)}
                                           accept="image/jpg, image/jpeg, image/png"
                                           multiple={this.props.multiple}/>
                                </div>
                                <Panel header="Kişi Bilgileri" toggleable={false}>
                                    <div className="p-grid p-md-10">
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">T.C
                                            </label>
                                            <span style={{color: "red"}}> (*)</span>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <InputText value={this.state.pers_tcid}
                                                       onChange={(e) => this.logChange(e)}
                                                       name="pers_tcid"
                                                       id="pers_tcid"
                                                       minLength={11}
                                                       maxLength={11}
                                                       keyfilter="int"
                                                       required/>
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Kullanıcı Adı </label>
                                            <span style={{color: "red"}}> (*)</span>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <InputText
                                                value={this.state.pers_name}
                                                onChange={(e) => this.logChange(e)}
                                                name="pers_name"
                                                id="pers_name"
                                                minLength={2}
                                                maxLength={50}
                                                required/>
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Soyad</label>
                                            <span style={{color: "red"}}> (*)</span>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <InputText
                                                id="pers_surname"
                                                value={this.state.pers_surname}
                                                onChange={(e) => this.logChange(e)}
                                                name="pers_surname"
                                                minLength={2}
                                                maxLength={50}
                                                required/>
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">E-Posta</label>
                                            <span style={{color: "red"}}> (*)</span>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <InputText
                                                id="user_email"
                                                value={this.state.user_email}
                                                onChange={(e) => this.logChange(e)}
                                                name="user_email"
                                                minLength={2}
                                                maxLength={50}
                                                required/>
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Doğum Tarihi</label>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <Calendar
                                                id="pers_birthday"
                                                value={this.state.pers_birthday}
                                                locale="tr"
                                                name="pers_birthday"
                                                dateFormat="dd/mm/yy"
                                                onChange={(e) => this.logChange(e)}
                                                monthNavigator={true}
                                                yearNavigator={true}
                                                yearRange="1910:2021"/>
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            Cinsiyet
                                            <span style={{color: "red"}}> (*)</span>
                                        </div>
                                        <div className="p-col-12 p-md-10"
                                             align="left">
                                            <div className="p-grid">
                                                {genderOptionItems}
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Kurum</label>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <Dropdown options={instOptionItems}
                                                      inputId="institution"
                                                      name="institution"
                                                      value={this.state.institution}
                                                      onChange={e => this.institutionInitalize(e.target.value)}
                                                      filter={true}
                                                      showClear={true}
                                                      required={true}
                                                      placeholder="Lütfen Kurumunuzu Seçiniz"/>

                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Departman</label>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <Dropdown options={deptOptionItems}
                                                      inputId="department"
                                                      name="department"
                                                      value={this.state.department}
                                                      onChange={e => this.setState({department: e.target.value})}
                                                      filter={true}
                                                      showClear={true}
                                                      required={true}
                                                      placeholder="Lütfen Departmanınızı Seçiniz"/>

                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Ünvanı</label>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <InputText id="pers_title"
                                                       value={this.state.pers_title}
                                                       onChange={(e) => this.logChange(e)}
                                                       name="pers_title"/>
                                        </div>
                                    </div>
                                </Panel>
                                <br/><br/>

                                <Panel header="Kullanıcı Bilgileri" toggleable={false}>
                                    <div className="p-grid p-md-10">
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Kullanıcı Adı</label>
                                            <span style={{color: "red"}}> (*)</span>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <InputText
                                                id="user_username"
                                                name="user_username"
                                                value={this.state.user_username}
                                                onChange={(e) => this.logChange(e)}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Yeni Şifre </label>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <Password
                                                name="user_password"
                                                value={this.state.user_password}
                                                onChange={(e) => this.logChange(e)}
                                            />
                                        </div>
                                        <div className="p-col-12 p-md-2">
                                            <label htmlFor="input">Şifre Tekrar</label>
                                        </div>
                                        <div className="p-col-12 p-md-10">
                                            <Password
                                                id="confirm_password"
                                                name="confirm_password"
                                                value={this.state.confirm_password}
                                                onChange={(e) => this.logChange(e)}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                                <br/><br/>

                            </center>

                            <Panel header="İletişim Bilgileri" toggleable={false}>
                                <div className="p-grid p-md-10">
                                    <DataTable
                                        value={this.state.contacts}
                                        emptyMessage="İletişim Bilgisi Eklenmedi"
                                        selectionMode="single"
                                        reorderableColumns={true}>
                                        <Column
                                            header="İşlevler"
                                            body={this.contacttypeButtons.bind(this)}
                                            style={{textAlign: 'center', width: '6em'}}/>
                                        <Column
                                            field="ctyp_name"
                                            header="İletişim Türü"
                                            sortable={true}
                                            filter={true}/>
                                        <Column
                                            field="pcon_content"
                                            header="İçerik"
                                            sortable={true}
                                            filter={true}/>
                                    </DataTable>
                                    <div className="p-col-12 p-md-4">
                                        <Dialog header="Yeni İletişim Bilgileri Ekle" visible={this.state.contact_popup}
                                                style={{width: '40vw'}}
                                                onHide={() => this.setState({contact_popup: false})} maximizable>

                                            <div className="p-grid p-md-10">
                                                <Dropdown options={contactTypesItems}
                                                          inputId="contact_type"
                                                          name="contact_type"
                                                          value={this.state.contact_type}
                                                          onChange={e => this.setState({contact_type: e.target.value})}
                                                          showClear={true}
                                                          required={true}
                                                          placeholder="İletişim Türünü Seçiniz"
                                                />
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <InputTextarea
                                                    id="contact_content"
                                                    name="contact_content"
                                                    value={this.state.contact_content}
                                                    onChange={(e) => this.logChange(e)}
                                                    rows={7}
                                                    cols={30}
                                                    autoResize={true}>
                                                </InputTextarea>
                                            </div>
                                            <div className="p-grid">
                                                <div className="p-g-12">
                                                    <Button
                                                        icon="pi pi-check"
                                                        type="button"
                                                        style={{
                                                            visibility: this.state.btn_add_visible ? 'visible' : 'hidden',
                                                            width: this.state.btn_add_visible ? '' : '0px'
                                                        }}
                                                        onClick={this.addContact}
                                                        label="Ekle"/>
                                                </div>
                                                <div className="p-g-12 ">
                                                    <Button
                                                        icon="pi pi-check"
                                                        type="button"
                                                        style={{
                                                            visibility: this.state.btn_update_visible ? 'visible' : 'hidden',
                                                            width: this.state.btn_update_visible ? '' : '0px'
                                                        }}
                                                        onClick={this.updateContact}
                                                        label="Güncelle"/>
                                                </div>
                                                <div className="p-g-12 ">
                                                    <Button
                                                        type="reset"
                                                        icon="pi pi-times"
                                                        onClick={() => this.setState({
                                                            contact_popup: false,
                                                            btn_update_visible: false,
                                                            btn_add_visible: false
                                                        })}
                                                        label="Vazgeç"
                                                        className="p-button-secondary"/>
                                                </div>
                                            </div>
                                        </Dialog>
                                        <Button
                                            type="button"
                                            icon="pi pi-plus-circle"
                                            label="Yeni İletişim Ekle"
                                            onClick={() => this.setState({
                                                contact_popup: true,
                                                btn_add_visible: true
                                            })}/>
                                    </div>
                                </div>
                            </Panel>
                            <div className="p-col-12 p-md-2" align="left">
                                <Button
                                    label="Kaydet"
                                    icon="pi pi-save"
                                    disabled={this.state.submit_btn_disable}
                                />
                            </div>
                        </div>

                    </div>

                </form>
                <Dialog header={this.state.dialog_header_message}
                        visible={this.state.registration_dialog_visibility}
                        style={{width: '50%'}} modal={true}
                        footer={registration_dialog_footer}
                        onHide={(e) => this.setState({registration_dialog_visibility: false})}>
                    <div>{this.state.registration_message}
                    </div>
                </Dialog>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        management: state.management
    }
};

const mapDispatchToProps = dispatch => {
    return {
        register: (user_data) => dispatch(auth.register(user_data)),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// ./src/pages/authentication/Register.jsx